const LEAGUES_PATH_PREFIXES = ["/product-management/competitions", "/product-management/editions"] as const;

export function isProductManagementLeaguesPath(pathname: string): boolean {
	return LEAGUES_PATH_PREFIXES.some((path) => pathname.startsWith(path));
}
